import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { TimekeeperService } from 'services/TimekeeperService';
import { TipoAcumulacionEnum } from 'repository/timekeeper/@types/TypeAccrualEnum';
import { AccrualCodeCreate } from 'repository/timekeeper/@types/AccrualCode';
import { FormAccrualCode } from './FormAccrualCode';
import { FormValues } from 'schemas/AccrualCode';
import { toIsoDurationFromHourMinute } from 'utils/Duration';

interface CreateProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    rows: any;
    reloading: () => void;
}

const timekeeperService = new TimekeeperService();

export const CreateAccrualCode: FC<CreateProps> = ({ open, setOpen, rows, reloading }) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const handleSubmit = async (values: FormValues) => {
        let payload: AccrualCodeCreate;

        if (values.type_accrual === TipoAcumulacionEnum.DIAS) {
            payload = {
                name: values.name,
                abbreviation: values.abbreviation,
                type_accrual: values.type_accrual,
                hour_per_day: toIsoDurationFromHourMinute(values.hour_per_day as string),
                allow_manual_edits: values.allow_manual_edits,
                show_code: values.show_code,
            };
        } else {
            payload = {
                name: values.name,
                abbreviation: values.abbreviation,
                type_accrual: values.type_accrual,
                allow_manual_edits: values.allow_manual_edits,
                show_code: values.show_code,
            };
        }

        try {
            await timekeeperService.accrual_code.create(payload);
            enqueueSnackbar(t('accruals.accrual_codes.dialog.alerts.add.success'), { variant: 'success' });
            reloading();
        } catch (error) {
            console.error(error);
            enqueueSnackbar(t('accruals.accrual_codes.dialog.alerts.add.error'), { variant: 'error' });
            throw error;
        }
    };

    return (
        <FormAccrualCode
            open={open}
            setOpen={setOpen}
            rows={rows}
            initialValues={{
                name: '',
                abbreviation: '',
                type_accrual: TipoAcumulacionEnum.HORAS,
                hour_per_day: '08:00',
                allow_manual_edits: true,
                show_code: true,
            }}
            titleKey={'accruals.accrual_codes.dialog.titles.add'}
            onSubmit={handleSubmit}
        />
    );
};
